<template>
  <div>
   <h3 style="background: rgb(0, 123, 255); padding: 10px; line-height: 42px; text-align: center; color: rgb(255, 255, 255);">{{ stepName }}</h3>
   <br>
   <form class="forms-sample" style="width:100%">
    <div v-for="field in fields" :key="field.name" class="form-group row">
      <label class="col-sm-3 col-form-label" :for="field.name">{{ field.label }}</label>
      <div class="col-sm-9">
      <input class="form-control" 
        v-if="field.inputType === 'text'"
        v-model="formData[field.name]" 
        :placeholder="field.label"
        :required="field.required"
        :id="field.name"
      />
    <select class="form-control border-primary" 
      v-if="field.inputType === 'select' && field.name=='District'" 
      v-model="formData[field.name]" 
      :id="field.name"
      :required="field.required"
    >
      <option value="">Select a district</option>
      <option v-for="option in this.districtlist " :key="option.id" :value="option.id">
        {{ option.name }}
      </option>
    </select>
    <select class="form-control border-primary" 
      v-if="field.inputType === 'select' && field.name=='Upazila'" 
      v-model="formData[field.name]" 
      :id="field.name"
      :required="field.required"
    >
     <option value="">Select a upazila</option>
      <option v-for="option in this.upazilalist " :key="option.id" :value="option.id">
        {{ option.name }}
      </option>
    </select>

    </div>
   </div>
  </form>
  <button class="btn btn-success mr-2" v-if="step > 1" @click="previousStep">Previous</button>
  <button class="btn btn-success mr-2" @click="nextStep">Next</button>
  </div>
</template>

<script>
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
export default {
  props: {
    step: Number,
    stepName: String,
    fields: Array, 
    formData: Object
  },
  data(){
    return{
      districtlist:[],
      upazilalist:[],
    }
   
  },
  computed:{
    url(){
      return this.$store.state.url;
    }

  },
  mounted(){
   this.getalldistrict();
   this.getallpazila();
  },
  methods: {
    nextStep() {
      if (this.isValid()) {
        this.$emit('advance');
      } else {
        toast.warning("Please fill all required fields", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });
      }
    },
    previousStep() {
    this.$emit('retreat');
    },
    isValid() {
      for (const field of this.fields) {
        if (field.required && !this.formData[field.name]) {
          return false;
        }
      }
      return true;
    },
    getalldistrict(){
        axios.get(this.url+'getalldistrict').then(response=>{
         const districts = response.data;
         this.districtlist = districts.map(district => ({
                  id: district.id,
                  name: district.districtname
                }));
      

    })
   },
   getallpazila(){
    axios.get(this.url+'getallpazila').then(response=>{
     const upazilas = response.data;
     this.upazilalist = upazilas.map(upazila => ({
          id: upazila.id,
          name: upazila.Upazila
    }));

    })
  },
  }
}
</script>